var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdyenPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 152,
    viewBox: "0 0 362 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "404 Page not found",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181 3C221.3 3 254 35.7 254 76C254 116.3 221.3 149 181 149C140.7 149 108 116.3 108 76C108 35.7 140.7 3 181 3ZM181 1C139.6 1 106 34.6 106 76C106 117.4 139.6 151 181 151C222.4 151 256 117.4 256 76C256 34.6 222.4 1 181 1Z",
    fill: "#00112C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181 13C215.7 13 244 41.3 244 76C244 110.7 215.7 139 181 139C146.3 139 118 110.7 118 76C118 41.3 146.3 13 181 13ZM181 11C145.1 11 116 40.1 116 76C116 111.9 145.1 141 181 141C216.9 141 246 111.9 246 76C246 40.1 216.9 11 181 11Z",
    fill: "#0066FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234 129L256 151",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96 113.5H1L76 1V151",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M361 113.5H266L273.2 102.6L341 1V151",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.1 76.8C221 76.8 224.2 73.6 224.2 69.7",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4 64.4C213.3 64.4 216.5 61.2 216.5 57.3",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.9 55.9C200.8 55.9 204 52.7 204 48.8",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.8 52.5C186.7 52.5 189.9 49.3 189.9 45.4",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2 96C169.6 96 161 87.4 161 76.8C161 66.2 169.6 57.6 180.2 57.6C190.8 57.6 199.4 66.2 199.4 76.8C199.4 87.4 190.8 96 180.2 96Z",
    fill: "#0066FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2 58.6C190.2 58.6 198.4 66.8 198.4 76.8C198.4 86.8 190.2 95 180.2 95C170.2 95 162 86.8 162 76.8C162.1 66.8 170.2 58.6 180.2 58.6ZM180.2 56.6C169.1 56.6 160 65.6 160 76.8C160 88 169 97 180.2 97C191.4 97 200.4 88 200.4 76.8C200.4 65.6 191.4 56.6 180.2 56.6Z",
    fill: "#00112C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143.4 76.8C143.4 76.8 154.2 52.6 180.3 52.6C206.4 52.6 217.2 76.8 217.2 76.8C217.2 76.8 206.4 101 180.3 101C154.2 101 143.4 76.8 143.4 76.8Z",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2 84.6C184.508 84.6 188 81.1078 188 76.8C188 72.4922 184.508 69 180.2 69C175.892 69 172.4 72.4922 172.4 76.8C172.4 81.1078 175.892 84.6 180.2 84.6Z",
    fill: "#00112C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.3 90.7C190.608 90.7 194.1 87.2078 194.1 82.9C194.1 78.5922 190.608 75.1 186.3 75.1C181.992 75.1 178.5 78.5922 178.5 82.9C178.5 87.2078 181.992 90.7 186.3 90.7Z",
    fill: "#0066FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.4 78.8C142.504 78.8 143.4 77.9046 143.4 76.8C143.4 75.6954 142.504 74.8 141.4 74.8C140.295 74.8 139.4 75.6954 139.4 76.8C139.4 77.9046 140.295 78.8 141.4 78.8Z",
    stroke: "#00112C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyenPageNotFound);
export default __webpack_public_path__ + "static/media/adyen-page-not-found.63075109.svg";
export { ForwardRef as ReactComponent };